import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import {
  useGetStatisticsRTISubmission,
  useGetStatisticsOthers,
} from '@nxsys/hooks/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useNavigateWithQuery } from '@nxsys/hooks/useNavigateWithQuery';
import { useEffect, useMemo, useState } from 'react';
import EPSModal from './components/EPSModal';
import FPSModal from './components/FPSModal';

const RTISubmission = () => {
  const { value, loading, run } = useGetStatisticsRTISubmission();
  const {
    value: othersValue,
    run: runOthers,
  } = useGetStatisticsOthers();
  const data = useMemo(() => value?.data, [value]);
  const othersData = useMemo(() => othersValue?.data, [othersValue]);
  const navigate = useNavigateWithQuery();

  const [isEPSModalOpen, setIsEPSModalOpen] = useState(false);
  const [isFPSModalOpen, setIsFPSModalOpen] = useState(false);

  useEffect(() => {
    run();
    runOthers();
  }, []);

  useEffect(() => {
    const handleReload = () => {
      run();
      runOthers();
    };
    window.addEventListener('dashboard:reload-rti', handleReload);
    return () => window.removeEventListener('dashboard:reload-rti', handleReload);
  }, []);

  const fpsErrors = othersData?.FPS?.countErrors ?? 0;
  const epsErrors = othersData?.EPS?.countErrors ?? 0;

  const items = [
    {
      title: data?.totalFPS,
      description: 'FPS',
      icon: <Icons.IconFileText />,
      onClick: () => setIsFPSModalOpen(true),
      errorCount: fpsErrors,
      errorRoute: '/rti-filings/fps',
    },
    {
      title: data?.totalEPS,
      description: 'EPS',
      icon: <Icons.IconFileText />,
      onClick: () => setIsEPSModalOpen(true),
      errorCount: epsErrors,
      errorRoute: '/rti-filings/eps',
    },
  ];

  return (
    <div className="RTISubmission">
      <AppCard className="p-[24px]" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconStarShooting" title="RTI Submission" />
        </div>
        <div className="grid grid-cols-2 gap-[16px] max-sm:grid-cols-1">
          {items.map((item) => (
            <div
              key={item.description}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px]"
              onClick={item.onClick}
            >
              <div className="flex items-center justify-between gap-x-[8px] mb-[34px]">
                <div className="bg-cyan-100 rounded-[8px] p-[8px]">
                  {item.icon}
                </div>
                <Icons.IconArrowRight />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <div className="text-[22px] font-bold mb-[8px]">
                    {item.title}
                  </div>
                  <div className="text-[14px] font-bold">
                    {item.description}
                  </div>
                </div>
                {item.errorCount > 0 && (
                  <div
                    className="flex flex-col items-center bg-[#FEF2F2] border border-[#FCA5A5] rounded-[8px] px-[12px] py-[6px] cursor-pointer hover:bg-[#FEE2E2] transition-colors"
                    onClick={(e) => {
                      e.stopPropagation();
                      navigate(item.errorRoute);
                    }}
                  >
                    <div className="text-[16px] font-bold text-[#DC2626]">
                      {item.errorCount}
                    </div>
                    <div className="text-[11px] font-medium text-[#DC2626]">
                      Errors
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </AppCard>
      <EPSModal
        isOpen={isEPSModalOpen}
        toggle={() => setIsEPSModalOpen(!isEPSModalOpen)}
      />
      <FPSModal
        isOpen={isFPSModalOpen}
        toggle={() => setIsFPSModalOpen(!isFPSModalOpen)}
      />
    </div>
  );
};

export default RTISubmission;
